
interface SelectTimeFrameProps {
    selectTimeFrame: DefaultTimeFrame;
    setSelectTimeFrame: (value: DefaultTimeFrame) => void;
    listTimeFrames: DefaultTimeFrame[];
  }

  function SelectTimeFrame({
    selectTimeFrame,
    setSelectTimeFrame,
    listTimeFrames
  }: SelectTimeFrameProps) {
    return (
      <div>
        <select
          value={selectTimeFrame}
          onChange={(e) => {
              setSelectTimeFrame(e.target.value as DefaultTimeFrame);
          }}
          className='mr-2 lg:mr-2 p-1 text-[14px] rounded border bg-white dark:bg-gray-700 text-gray-900 dark:text-white h-[32px]'
        >
          {listTimeFrames.map((time) => (
            <option key={time} value={time}>
              {time}
            </option>
          ))}
        </select>
      </div>
    );
  }
  
  export default SelectTimeFrame;